// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  development: false,
  envName: 'test',
  beta: false,
  imageUrl: 'http://api.hilti-typicals.auriga.ru/api/',
  api_url: 'http://hilti-isb-api.netsoftware.pl/api/v1/',
  constraintsUrl: 'http://hilti-constraints-api.netsoftware.pl/api/Constraints/',
  serviceUrl: 'http://localhost:3000/api/v1/',
  reportsUrl: 'http://hilti-isb-api.netsoftware.pl/api/reports',
    versionNumber: '1.0.0.1',
  authConfig: {
    'callbackUrl': 'http://localhost:4200/oauth_callback',
    'authorizeUrl': 'http://localhost:4200/hc/oauth/v1/authorize?' +
    'client_id=__clientId__&redirect_uri=__callbackUrl__&response_type=code&scope=HC.Request.AllScopes&lang=__lang__&state=__state__',
    'clientId': 'c43c12de2a714bf9ab78b48ff56247be',
    'tokenUrl': 'http://localhost:4200/hc/oauth/v1/tokens',
    'logoutUrl': 'http://localhost:4200/hc/oauth/v1/logout?ssotoken=invalidate&client_id=__clientId__&lang=__lang__&access_token=__accessToken__'
  }
};
